module.exports = __webpack_public_path__ + "bb0cb5a5d873ed02152b5633236362eb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-witch-s.png
// module id = 1918
// module chunks = 0